
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30902',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30902",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55470",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8433",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11889",
  "I18n": "static-7.1691",
  "quartz": "static-1.7567",
  "quartz-config": "static-1.1345",
  "quartz-core": "static-1.6786",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1018",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55457",
  "feedback-utils": "static-1.55461",
  "forms-embed-utils-lib": "static-1.4862",
  "forms-utils-lib": "static-1.13218",
  "foundations-assets": "static-1.5285",
  "foundations-components": "static-1.8631",
  "foundations-theming": "static-1.4875",
  "hub-http": "static-1.6608",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12196",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4183",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17127",
  "react-select-plus": "static-1.116",
  "react-utils": "static-2.5613",
  "react-virtualized": "static-2.110",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.511",
  "tinymce-plugins": "static-1.58379",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8835",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3844",
  "quartz-webpack": "static-1.3791",
  "foundations-theming-specialty": "static-1.2591",
  "property-description-translator": "static-1.4218",
  "HeadJS": "static-2.811",
  "framer-motion": "static-1.82",
  "hs-test-utils-bend-plugin": "static-1.3544",
  "msw": "static-1.39",
  "msw-config": "static-1.16",
  "testing-library": "static-1.162",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4705",
  "jasmine-runner": "static-1.6844",
  "opentelemetry-fe-types": "static-1.182",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.896",
  "hubspotter-http": "static-1.4918",
  "mobile-manifest-mixins": "static-1.592",
  "module-federation": "static-1.36",
  "opentelemetry-fe": "static-1.557",
  "quartz-auth": "static-1.1242",
  "quartz-head": "static-1.1232",
  "quartz-i18n": "static-1.1242",
  "quartz-routing": "static-1.997",
  "quartz-test": "static-1.1242",
  "quartz-tracking": "static-1.946",
  "trellis-components": "static-1.2913",
  "ui-fonts": "static-1.1151",
  "usage-tracker-container": "static-1.7700",
  "usage-tracker-core": "static-1.7560",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.285",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8578",
  "sanitize-text": "static-1.8553",
  "PatternValidationJS": "static-1.3285",
  "ReduxMessenger": "static-2.10767",
  "outpost": "static-1.4533",
  "rpc-client-utils": "static-1.5063",
  "sanitize": "static-1.4867",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4900",
  "floating-ui": "static-1.66",
  "hs-story-utils": "static-1.9822",
  "react-aria": "static-1.75",
  "react-create-root-preference": "static-1.88",
  "tanstack-table": "static-1.64",
  "trellis-assets": "static-1.2894",
  "bend-plugin-foundations-theming": "static-1.3358",
  "foundations-theming-base": "static-1.3860",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.352",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9888",
  "atom": "static-1.5476",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8318",
  "ContentUtils": "static-1.69308",
  "data-token-picker": "static-1.17015",
  "file-manager-components": "static-1.24690",
  "FileManagerCore": "static-1.40189",
  "FileManagerLib": "static-1.40330",
  "frontend-preferences-client": "static-1.8316",
  "hub-http-contrib": "static-1.3422",
  "interframe": "static-3.5138",
  "layout-dnd-components": "static-1.13102",
  "layout-dnd-utils": "static-1.12077",
  "property-translator": "static-1.5777",
  "react-codemirror": "static-1.11038",
  "react-colorpicker": "static-2.10609",
  "reference-resolvers-lite": "static-1.8500",
  "rich-text-lib": "static-1.20440",
  "tinymce-data": "static-1.41350",
  "tinymce-themes": "static-1.57235",
  "ui-addon-emoji-picker": "static-1.10265",
  "ui-addon-sales-email": "static-1.5599",
  "ui-brand-identity-lib": "static-1.16750",
  "bender-build-tools": "static-1.3472",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.98",
  "hub-http-shared-msw-handlers": "static-1.10767",
  "hubspotter-http-shared-msw-handlers": "static-1.10765",
  "usage-tracker-session-replay": "static-1.5396",
  "base-ui": "static-1.25",
  "react-day-picker": "static-1.13",
  "trellis-theming": "static-1.1375",
  "tanstack-virtual": "static-1.41",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.473",
  "chirp-fetch": "static-1.2296",
  "stylex-utils": "static-1.157",
  "chatspot-core": "static-1.23404",
  "copilot-toolkit": "static-1.12005",
  "customer-data-objects-ui-components": "static-1.13427",
  "data-fetching-client": "static-1.10043",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5156",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29468",
  "usage-tracker": "static-1.7710",
  "cms-field-types": "static-1.5208",
  "content-icons-ui": "static-1.2415",
  "integrations-lib": "static-1.17250",
  "customer-data-objects": "static-1.8089",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.1965",
  "apollo-link-hub-http": "static-2.5016",
  "apollo-stack-hubspot": "static-3.97",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4539",
  "poll-commands": "static-1.3868",
  "ui-addon-iframeable": "static-1.9476",
  "video-components-external": "static-1.12305",
  "video-data-lib": "static-1.35963",
  "breeze-artifacts-sdk": "static-1.627",
  "audio-components": "static-1.6467",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29942",
  "FileManagerImages": "static-1.37841",
  "foundations-components-legacy": "static-1.1656",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.657",
  "ui-universal-auth": "static-1.9585",
  "urlinator": "static-1.4912",
  "video-components": "static-1.14307",
  "video-embed": "static-1.36797",
  "ts-schema": "static-1.4352",
  "ContentData": "static-1.69383",
  "layout-data-lib": "static-1.10402",
  "react-dnd-compat": "static-1.5010",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1941",
  "external-options-client-types": "static-1.4400",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7292",
  "hs-promise-utils": "static-1.5986",
  "inbound-db-properties-service-client": "static-1.4101",
  "NamespacedHubStyle": "static-2.9317",
  "growth-onboarding-confetti": "static-1.3460",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11545",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5834",
  "magpie-types": "static-1.5294",
  "simple-logging-lib": "static-1.3449",
  "avatar-components": "static-1.2879",
  "customer-data-ui-utilities": "static-1.10228",
  "growth-onboarding-feedback-components": "static-1.6982",
  "flux-actions": "static-1.377",
  "hubspot-apollo-client": "static-1.5270",
  "integrations-error-boundary-lib": "static-1.14665",
  "integrations-tracking-lib": "static-1.6008",
  "laboratory-lib": "static-3.7547",
  "native-integrations-shared-strings": "static-1.8159",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10668",
  "unified-auth": "static-1.1099",
  "breeze-engine-chat-components": "static-1.943",
  "breeze-engine-core": "static-1.1243",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1032",
  "navigation-messaging": "static-1.8335",
  "content-media-composition-data-lib": "static-1.13437",
  "content-media-compositions": "static-2.17444",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19533",
  "nudge-client-utils": "static-1.3282",
  "unified-auth-core-lib": "static-1.1381",
  "social-insights-client-types": "static-1.22795",
  "advanced-menus-core": "static-1.15698",
  "advanced-menus-lib": "static-1.12511",
  "ExportDialog": "static-6.10774",
  "ui-memberships-settings-lib": "static-1.35008",
  "conditional-properties-service-client": "static-1.4074",
  "crm-pipelines-api-client-types": "static-1.4405",
  "fdsr-migration-layer": "static-1.411",
  "framework-builder-read-service-client": "static-1.4280",
  "framework-data-schema-quick-fetch": "static-1.7197",
  "inbound-db-meta-service-client": "static-1.3732",
  "multi-currency-client-types": "static-1.3969",
  "persist-promise": "static-1.4098",
  "foundations-components-test-utils": "static-1.6114",
  "reactive-lib": "static-1.1117",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.729",
  "universal-page-editor-lib": "static-1.3408",
  "adobe-sign-auth-lib": "static-1.628",
  "ads-unified-auth-lib": "static-1.1691",
  "custom-vendor-connection-lib": "static-1.149",
  "google-sheets-integration-lib": "static-1.1193",
  "microsoft-drive-auth-lib": "static-1.349",
  "surveymonkey-integration-lib": "static-1.703",
  "slack-ui-library": "static-1.10795",
  "bend-plugin-pulse": "static-1.535",
  "event-emitter": "static-1.1355",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3039",
  "nudge-renderer-utils": "static-1.3358",
  "onboarding-tours": "static-1.17272",
  "whisper-core-api": "static-1.7494",
  "fsm": "static-1.4150",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15697",
  "simple-menus-lib": "static-1.17214",
  "settings-ui-lib": "static-1.12925",
  "crm-record-cards-service-types": "static-1.3828",
  "location-customization-utils-lib": "static-1.10276",
  "getting-started-shared-tasks": "static-1.19419",
  "growth-data-modal": "static-1.6018",
  "growth-onboarding-next-action-utils": "static-1.2849",
  "navigation-components": "static-1.19008",
  "onboarding-tours-client": "static-1.5487",
  "onboarding-tours-utils": "static-1.1339",
  "ui-shepherd-tracker": "static-1.8049",
  "user-context": "static-1.5473",
  "react-flip-move": "static-1.81",
  "onboarding-data-sync-lib": "static-1.2704",
  "growth-onboarding-next-action-components": "static-1.2877",
  "user-context-client": "static-1.4906",
  "nest": "static-1.632",
  "getting-started-shared-tasks-store": "static-1.18537",
  "InboxConnectUtils": "static-4.15711",
  "meetings-connect-utils-lib": "static-1.8011",
  "onboarding-scopes": "static-1.6850"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30902",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55470",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8433",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11889",
  "I18n": "/I18n/static-7.1691",
  "quartz": "/quartz/static-1.7567",
  "quartz-config": "/quartz-config/static-1.1345",
  "quartz-core": "/quartz-core/static-1.6786",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1018",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55457",
  "feedback-utils": "/feedback-utils/static-1.55461",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4862",
  "forms-utils-lib": "/forms-utils-lib/static-1.13218",
  "foundations-assets": "/foundations-assets/static-1.5285",
  "foundations-components": "/foundations-components/static-1.8631",
  "foundations-theming": "/foundations-theming/static-1.4875",
  "hub-http": "/hub-http/static-1.6608",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12196",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4183",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17127",
  "react-select-plus": "/react-select-plus/static-1.116",
  "react-utils": "/react-utils/static-2.5613",
  "react-virtualized": "/react-virtualized/static-2.110",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.511",
  "tinymce-plugins": "/tinymce-plugins/static-1.58379",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8835",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3844",
  "quartz-webpack": "/quartz-webpack/static-1.3791",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2591",
  "property-description-translator": "/property-description-translator/static-1.4218",
  "HeadJS": "/HeadJS/static-2.811",
  "framer-motion": "/framer-motion/static-1.82",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3544",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.16",
  "testing-library": "/testing-library/static-1.162",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4705",
  "jasmine-runner": "/jasmine-runner/static-1.6844",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.182",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.896",
  "hubspotter-http": "/hubspotter-http/static-1.4918",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.592",
  "module-federation": "/module-federation/static-1.36",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.557",
  "quartz-auth": "/quartz-auth/static-1.1242",
  "quartz-head": "/quartz-head/static-1.1232",
  "quartz-i18n": "/quartz-i18n/static-1.1242",
  "quartz-routing": "/quartz-routing/static-1.997",
  "quartz-test": "/quartz-test/static-1.1242",
  "quartz-tracking": "/quartz-tracking/static-1.946",
  "trellis-components": "/trellis-components/static-1.2913",
  "ui-fonts": "/ui-fonts/static-1.1151",
  "usage-tracker-container": "/usage-tracker-container/static-1.7700",
  "usage-tracker-core": "/usage-tracker-core/static-1.7560",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.285",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8578",
  "sanitize-text": "/sanitize-text/static-1.8553",
  "PatternValidationJS": "/PatternValidationJS/static-1.3285",
  "ReduxMessenger": "/ReduxMessenger/static-2.10767",
  "outpost": "/outpost/static-1.4533",
  "rpc-client-utils": "/rpc-client-utils/static-1.5063",
  "sanitize": "/sanitize/static-1.4867",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4900",
  "floating-ui": "/floating-ui/static-1.66",
  "hs-story-utils": "/hs-story-utils/static-1.9822",
  "react-aria": "/react-aria/static-1.75",
  "react-create-root-preference": "/react-create-root-preference/static-1.88",
  "tanstack-table": "/tanstack-table/static-1.64",
  "trellis-assets": "/trellis-assets/static-1.2894",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3358",
  "foundations-theming-base": "/foundations-theming-base/static-1.3860",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.352",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9888",
  "atom": "/atom/static-1.5476",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8318",
  "ContentUtils": "/ContentUtils/static-1.69308",
  "data-token-picker": "/data-token-picker/static-1.17015",
  "file-manager-components": "/file-manager-components/static-1.24690",
  "FileManagerCore": "/FileManagerCore/static-1.40189",
  "FileManagerLib": "/FileManagerLib/static-1.40330",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8316",
  "hub-http-contrib": "/hub-http-contrib/static-1.3422",
  "interframe": "/interframe/static-3.5138",
  "layout-dnd-components": "/layout-dnd-components/static-1.13102",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12077",
  "property-translator": "/property-translator/static-1.5777",
  "react-codemirror": "/react-codemirror/static-1.11038",
  "react-colorpicker": "/react-colorpicker/static-2.10609",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8500",
  "rich-text-lib": "/rich-text-lib/static-1.20440",
  "tinymce-data": "/tinymce-data/static-1.41350",
  "tinymce-themes": "/tinymce-themes/static-1.57235",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10265",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5599",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16750",
  "bender-build-tools": "/bender-build-tools/static-1.3472",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.98",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10767",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10765",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5396",
  "base-ui": "/base-ui/static-1.25",
  "react-day-picker": "/react-day-picker/static-1.13",
  "trellis-theming": "/trellis-theming/static-1.1375",
  "tanstack-virtual": "/tanstack-virtual/static-1.41",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.473",
  "chirp-fetch": "/chirp-fetch/static-1.2296",
  "stylex-utils": "/stylex-utils/static-1.157",
  "chatspot-core": "/chatspot-core/static-1.23404",
  "copilot-toolkit": "/copilot-toolkit/static-1.12005",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13427",
  "data-fetching-client": "/data-fetching-client/static-1.10043",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5156",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29468",
  "usage-tracker": "/usage-tracker/static-1.7710",
  "cms-field-types": "/cms-field-types/static-1.5208",
  "content-icons-ui": "/content-icons-ui/static-1.2415",
  "integrations-lib": "/integrations-lib/static-1.17250",
  "customer-data-objects": "/customer-data-objects/static-1.8089",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1965",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5016",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.97",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4539",
  "poll-commands": "/poll-commands/static-1.3868",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9476",
  "video-components-external": "/video-components-external/static-1.12305",
  "video-data-lib": "/video-data-lib/static-1.35963",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.627",
  "audio-components": "/audio-components/static-1.6467",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29942",
  "FileManagerImages": "/FileManagerImages/static-1.37841",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1656",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.657",
  "ui-universal-auth": "/ui-universal-auth/static-1.9585",
  "urlinator": "/urlinator/static-1.4912",
  "video-components": "/video-components/static-1.14307",
  "video-embed": "/video-embed/static-1.36797",
  "ts-schema": "/ts-schema/static-1.4352",
  "ContentData": "/ContentData/static-1.69383",
  "layout-data-lib": "/layout-data-lib/static-1.10402",
  "react-dnd-compat": "/react-dnd-compat/static-1.5010",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1941",
  "external-options-client-types": "/external-options-client-types/static-1.4400",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7292",
  "hs-promise-utils": "/hs-promise-utils/static-1.5986",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4101",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9317",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3460",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11545",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5834",
  "magpie-types": "/magpie-types/static-1.5294",
  "simple-logging-lib": "/simple-logging-lib/static-1.3449",
  "avatar-components": "/avatar-components/static-1.2879",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10228",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6982",
  "flux-actions": "/flux-actions/static-1.377",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5270",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14665",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6008",
  "laboratory-lib": "/laboratory-lib/static-3.7547",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8159",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10668",
  "unified-auth": "/unified-auth/static-1.1099",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.943",
  "breeze-engine-core": "/breeze-engine-core/static-1.1243",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1032",
  "navigation-messaging": "/navigation-messaging/static-1.8335",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13437",
  "content-media-compositions": "/content-media-compositions/static-2.17444",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19533",
  "nudge-client-utils": "/nudge-client-utils/static-1.3282",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1381",
  "social-insights-client-types": "/social-insights-client-types/static-1.22795",
  "advanced-menus-core": "/advanced-menus-core/static-1.15698",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12511",
  "ExportDialog": "/ExportDialog/static-6.10774",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35008",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4074",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4405",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.411",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4280",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7197",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3732",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3969",
  "persist-promise": "/persist-promise/static-1.4098",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6114",
  "reactive-lib": "/reactive-lib/static-1.1117",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.729",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3408",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.628",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1691",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.149",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1193",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.349",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.703",
  "slack-ui-library": "/slack-ui-library/static-1.10795",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.535",
  "event-emitter": "/event-emitter/static-1.1355",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3039",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3358",
  "onboarding-tours": "/onboarding-tours/static-1.17272",
  "whisper-core-api": "/whisper-core-api/static-1.7494",
  "fsm": "/fsm/static-1.4150",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15697",
  "simple-menus-lib": "/simple-menus-lib/static-1.17214",
  "settings-ui-lib": "/settings-ui-lib/static-1.12925",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3828",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10276",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19419",
  "growth-data-modal": "/growth-data-modal/static-1.6018",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2849",
  "navigation-components": "/navigation-components/static-1.19008",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5487",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1339",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8049",
  "user-context": "/user-context/static-1.5473",
  "react-flip-move": "/react-flip-move/static-1.81",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2704",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2877",
  "user-context-client": "/user-context-client/static-1.4906",
  "nest": "/nest/static-1.632",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18537",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15711",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8011",
  "onboarding-scopes": "/onboarding-scopes/static-1.6850"
}
};
